import { ALL_CONTRACTS } from './contracts';
import { generateAllLinks, generatePostbackLink } from './generator';
import { validatePostbackUrl } from './validator';
/**
 * Minimal public surface for consumers (backend, backoffice, TMA, Telegram
 * bot, MCP): get a contract, generate a link, validate a link. Everything
 * else in this package is an implementation detail.
 */
export function getContract(platformId) {
    return ALL_CONTRACTS[platformId];
}
export function listPlatformIds() {
    return Object.keys(ALL_CONTRACTS);
}
export function generateLink(platformId, event, opts) {
    const contract = getContract(platformId);
    if (!contract) {
        throw new Error(`Unknown platform id "${platformId}"`);
    }
    return generatePostbackLink(contract, event, opts);
}
export function generateAllLinksForPlatform(platformId, opts) {
    const contract = getContract(platformId);
    if (!contract) {
        throw new Error(`Unknown platform id "${platformId}"`);
    }
    return generateAllLinks(contract, opts);
}
export function validateLink(platformId, url, opts = {}) {
    const contract = getContract(platformId);
    if (!contract) {
        throw new Error(`Unknown platform id "${platformId}"`);
    }
    return validatePostbackUrl(url, contract, opts);
}
//# sourceMappingURL=registry.js.map